import gettingStarted from './gettingStarted';
import reviewWorkflow from './reviewWorkflow';
import redFlags from './redFlags';
import coding from './coding';
import exporting from './exporting';
import support from './support';

/**
 * Help page sections in display order. Each body is markdown with "###"
 * sub-headings; the page renders the section title itself.
 */
export const HELP_SECTIONS = [
    { id: 'getting-started', title: 'Getting started', body: gettingStarted },
    { id: 'review-workflow', title: 'The review workflow', body: reviewWorkflow },
    { id: 'red-flags', title: 'Red flags', body: redFlags },
    { id: 'coding', title: 'The coding step', body: coding },
    { id: 'exporting', title: 'Getting documents out', body: exporting },
    { id: 'support', title: 'Support', body: support },
];
